var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.visible, title: "编辑", width: "500px" },
          on: { close: _vm.handleClose },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.dimensionDataSource,
                    size: "small",
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "广告网络",
                        prop: "adNetworkCode",
                        rules: {
                          required: true,
                          message: "请输入",
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.dimensionDataSource.adNetworkCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dimensionDataSource,
                                "adNetworkCode",
                                $$v
                              )
                            },
                            expression: "dimensionDataSource.adNetworkCode",
                          },
                        },
                        _vm._l(_vm.adverNetList, function (item) {
                          return _c("el-option", {
                            key: item.adNetworkCode,
                            attrs: {
                              label: item.adNetworkName,
                              value: item.adNetworkCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "类型",
                        prop: "type",
                        rules: {
                          required: true,
                          message: "请输入",
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.dimensionDataSource.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.dimensionDataSource, "type", $$v)
                            },
                            expression: "dimensionDataSource.type",
                          },
                        },
                        _vm._l(_vm.typeList, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "代码位名称",
                        prop: "adBitsName",
                        rules: {
                          required: true,
                          message: "请输入",
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.dimensionDataSource.adBitsName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dimensionDataSource,
                              "adBitsName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dimensionDataSource.adBitsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "代码位ID",
                        prop: "adBitsCode",
                        rules: {
                          required: true,
                          message: "请输入",
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.dimensionDataSource.adBitsCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dimensionDataSource,
                              "adBitsCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dimensionDataSource.adBitsCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.dimensionDataSource.type == 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "排序价格",
                            prop: "price",
                            rules: {
                              required: true,
                              message: "请输入",
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.dimensionDataSource.price,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dimensionDataSource,
                                  "price",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "dimensionDataSource.price",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitData } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }